import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface PartnerClicks {
  stats: Array<{
    label: string;
    value: string;
  }>;
  perGeoname: {
    [geoname: string]: number;
  };
}

export default (makeCall: MakeCall) => (
  partnerId: number,
  fromDate: string,
  toDate: string,
) =>
  makeCall<PartnerClicks>('GET', `/api/v2/partner/${partnerId}/clicks`, {
    query: {
      fromDate,
      toDate,
    },
  });
